var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DetailedTransferOut"},[_c('Cashier',_vm._b({attrs:{"isJust":false}},'Cashier',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }